import React from 'react';
import classnames from 'classnames';

import styles from './text.module.scss';

const baseClass = 'text';

export type TextProps = {
  tag?: 'p' | 'span';
  withShadow?: boolean;
  variant?:
    | 'caption-100'
    | 'caption-200'
    | 'caption-200-fixed'
    | 'caption-300'
    | 'caption-300-fixed'
    | 'caption-400-fixed'
    | 'label-100'
    | 'label-200'
    // Paragraphs [P]
    | 'P-300'
    | 'P-200'
    | 'P-100'
    // Legal [LGL]
    | 'LGL-100'
    // Depreciated
    | 'paragraph-100'
    | 'paragraph-200'
    | 'paragraph-300'
    | 'legal-100';
  'aria-label'?: string;
  role?: string;
  tabIndex?: number;
  onKeyDown?: React.KeyboardEventHandler<HTMLElement>;
  'aria-current'?: boolean | 'time' | 'false' | 'true' | 'page' | 'step' | 'location' | 'date';
  'aria-haspopup'?: boolean;
  'aria-expanded'?: boolean;
} & Pick<React.HTMLAttributes<HTMLParagraphElement>, 'children' | 'className' | 'id'>;

export const Text = React.forwardRef<HTMLParagraphElement, TextProps>(
  (
    {
      children,
      className,
      tag = 'p',
      id,
      variant = 'paragraph-100',
      withShadow,
      'aria-label': ariaLabel,
      onKeyDown,
      role,
      tabIndex,
      'aria-current': ariaCurrent,
      'aria-haspopup': ariaHaspopup,
      'aria-expanded': ariaExpanded
    },
    ref
  ) => {
    const classes = classnames(
      styles.text,
      styles[`${baseClass}--${variant}`],
      { [styles[`${baseClass}--${variant}--with-shadow`]]: withShadow },
      className
    );
    const Tag = tag;
    return (
      <Tag
        className={classes}
        id={id}
        aria-label={ariaLabel}
        onKeyDown={onKeyDown}
        role={role}
        tabIndex={tabIndex}
        aria-current={ariaCurrent}
        aria-haspopup={ariaHaspopup}
        aria-expanded={ariaExpanded}
        ref={ref}
      >
        {children}
      </Tag>
    );
  }
);

Text.displayName = 'Text';
